<template>
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7331 0.470215L19.7725 2.03021L16.4375 4.25146V5.93772H23.3731L23.8137 9.06272H25.1331L25.9606 14.6877H23.2481L22.1912 29.6877H8.80874L7.75124 14.6877H5.03937L5.86687 9.06272H7.18562L7.62687 5.93772H14.5619L14.5625 3.24771L18.7331 0.470215ZM21.3694 14.6877H9.63062L10.5562 27.8127H20.4437L21.3687 14.6877H21.3694ZM23.5137 10.9377H7.48624L7.21062 12.8127H23.7894L23.5144 10.9377H23.5137ZM21.7444 7.81271H9.25562L9.07937 9.06272H21.9206L21.7444 7.81271Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Beverage',
} as DefineComponent
</script>
